import { IComponentsService } from "../../interfaces/IComponentsService";
import { IComponentGameObject } from "../../interfaces/IComponentGameObject";
import { IComponent } from "../../interfaces/IComponent";
import { TableScreen } from "../screen/TableScreen";
import { Player } from "../player/Player";
import { Card } from "../card/Card";
import { TableStack } from "../cardStack/TableStack";
import { AppSettings } from "../managers/AppSettings";
import { CardsManager } from "../managers/CardsManager";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { PlayerProps } from "../player/Players";
import { AppTimings } from "../data/AppConstants";


export class TrickCollector
    implements IComponent {
    private table!: TableScreen;
    // private components!: IComponentsService;

    public tableStack: TableStack;
    private inputData: any;


    public constructor(tableStack: TableStack) {
        this.tableStack = tableStack;
    }

    public Init(go: IComponentGameObject, components: IComponentsService): void {
        this.table = go as TableScreen;
        // this.components = components;
    }

    public SetData(inputData: any): void {
        this.inputData = inputData;
        // console.log(TaskType[this.inputData.taskType]);
    }

    public GetData(): any {
        return this.inputData;
    }

    /*
        taskType: TaskTypeBelote.DEAL_PLAYER_TO_TABLE,
        onComplete: this.OnTaskComplete.bind(this),
        playerIndex: this.trickDealerIndex,
    */
    public Start(animate: boolean = false): void {
        // console.log("Start:",this.inputData)
        this.tableStack.NextSocketsIndex();
        
        // DEBUG card placement
        // return;

        const tableStackScale = this.tableStack.scale;
        let preTrickCollectDelay = animate ? 
            OptionsDataManager.GetTiming(AppTimings.preTrickCollectDelay) : 0;
        // preTrickCollectDelay = 5000;
        this.table.scene.time.delayedCall(preTrickCollectDelay, () => {
            const player: Player = this.table.players.GetPlayerByIndex(this.inputData.playerIndex);
            const playerProps: PlayerProps = player.GetPlayerProps();
            const stackCardsCount = this.tableStack.GetLength();
            const pickedCards: Card[] = this.tableStack.PickCards(stackCardsCount);
            pickedCards.forEach(card => {
                card.setPosition(
                    this.tableStack.x + card.x * tableStackScale,
                    this.tableStack.y + card.y * tableStackScale);
                card.scale = tableStackScale;
            })

            // start take cards
            AppAudioPlayer.PlaySfxRandomFromCollection([
                SoundEffectKeys.drawS3,
                SoundEffectKeys.drawS4,
                SoundEffectKeys.drawS5,
                SoundEffectKeys.drawS6,
                SoundEffectKeys.drawS7,
                SoundEffectKeys.drawS8,
                SoundEffectKeys.drawS10,
            ]);

            // add to table in reverse
            pickedCards.reverse();
            // this.table.add(pickedCards);
            this.table.cardContainer.add(pickedCards);
            // reverse again to add them to player from top to bottom
            pickedCards.reverse();
            let cardDealTableToPlayerDuration = OptionsDataManager.GetTiming(AppTimings.cardDealTableToPlayerDuration);
            let cardDealTableToPlayerDelay = OptionsDataManager.GetTiming(AppTimings.cardDealTableToPlayerDelay);
            // cardDealTableToPlayerDuration = 4000;
            // cardDealTableToPlayerDelay = 2000;
            pickedCards.forEach((card, i) => {
                this.table.scene.tweens.add({
                    targets: card,
                    duration: animate ? cardDealTableToPlayerDuration : 0,
                    x: player.x - playerProps.facing.x * 200,
                    y: player.y - playerProps.facing.y * 200,
                    delay: animate ? i * cardDealTableToPlayerDelay : 0,
                    ease: AppSettings.ease.genericDealEase,
                    onStartScope: this,
                    onComplete: () => {
                        // last card finished animation
                        if (i == pickedCards.length - 1) {
                            // pool
                            CardsManager.DropCards(pickedCards, false);

                            // complete task
                            this.inputData.onComplete(this.inputData.taskType, { playerIndex: this.inputData.playerIndex });
                        }
                    }
                })
            });
        });
    }
}